class ThirdsMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.MatchContentHeight()

    // Run on resize
    window.addEventListener('resize', this.MatchContentHeight.bind(this))
  }

  MatchContentHeight () {
    const fiftyFiftyTitles = this.querySelectorAll('.sec-Thirds_Title')

    let largestHeight = 0

    fiftyFiftyTitles.forEach((title) => {
      largestHeight = Math.max(largestHeight, title.offsetHeight)
    })

    fiftyFiftyTitles.forEach((title) => {
      title.style.height = `${largestHeight}px`
    })
  }
}

if (!customElements.get('thirds-media')) {
  customElements.define('thirds-media', ThirdsMedia)
}
